import React from 'react'
import TableHeader from '../../../../components/table/TableHeader'
import TableLayout from '../../../../components/table/TableLayout'
import {ILeader, leaderAllTimeProfit, leaderMonthlyProfit} from '../../../../apis/leader/getLeader'
import Text from '../../../../components/text/Text'
import TableItem from '../../../../components/table/TableItem'
import WizImage from '../../../../components/image/WizImage'
import {useImage} from '../../../../utils/image'
import {useDisplayNumber} from '../../../../utils/number'
import {useColor, useTag} from '../../../../utils/etc'
import Span from '../../../../components/text/Span'
import useQueryExchanges from '../../../../hooks/etc/useQueryExchanges'
import {useTime} from '../../../../utils/time'
import useNavigation from '../../../../hooks/useNavigation'

interface IProps {
    className?: string
    data?: ILeader[]
}

const GRID =
    'grid-cols-[auto_180px_200px_130px_100px_110px] lg:grid-cols-[1fr_120px_160px_90px_70px_70px] lg:gap-x-[10px] md:grid-cols-[1fr_100px_60px_50px]'

const LeaderListTable: React.FC<IProps> = ({className, data}) => {
    const {renderThumbnail} = useImage()
    const {renderPercent} = useDisplayNumber()
    const {getNumberColor} = useColor()
    const {renderStateColor} = useTag()
    const {localTimeString} = useTime()
    const {goLeaderDetail} = useNavigation()

    const {data: exchangeData} = useQueryExchanges()

    const userExchangeData = item => {
        return exchangeData?.find(exchange => exchange.name === item)
    }
    return (
        <div className={className}>
            <TableHeader className={`${GRID} sm:hidden`}>
                <Text>Leader</Text>
                <Text>Exchange</Text>
                <Text className={'md:hidden'}>Create At</Text>
                <Text>Profit</Text>
                <Text className={'md:hidden'}>MDD</Text>
                <Text>Copier</Text>
            </TableHeader>
            <TableLayout>
                {data?.map(list => (
                    <TableItem key={list?.id} className={`${GRID} sm:grid-cols-1 sm:p-[30px]`} onClick={() => goLeaderDetail(list?.id)}>
                        <div
                            className={
                                'flex items-center space-x-[10px] sm:flex-col sm:justify-center sm:text-center sm:gap-y-[10px]'
                            }>
                            <WizImage
                                src={renderThumbnail(list?.user_thumbnail)}
                                className={'w-[36px] flex-none h-[36px] rounded-full'}
                            />
                            <div>
                                <div className={'flex items-center gap-x-[7px] sm:justify-center'}>
                                    <Text className={'text-body2 sm:text-ti1'}>{list?.user_name}</Text>
                                    {list?.allow_copy === false && (
                                        <Text className={`${renderStateColor(false)}`}>Inactive</Text>
                                    )}
                                </div>
                                <Text className={'text-body3 text-font03'}>Leader Name : {list?.copy_lead_name}</Text>
                            </div>
                        </div>
                        <div className={'flex items-center space-x-[5px] sm:justify-center'}>
                            <WizImage src={userExchangeData(list?.exchange)?.icon} className={'flex-none w-[20px]'} />
                            <Text className={'sm:text-ti2'}>{userExchangeData(list?.exchange)?.display_name}</Text>
                        </div>
                        <div className={'md:hidden'}>
                            <Text className={'text-font03'}>{localTimeString(list?.created_at)}</Text>
                        </div>
                        <div className={'sm:text-center'}>
                            <Text className={'hidden sm:block text-ti3 text-font03'}>Profit</Text>
                            <Text className={`text-ti2 ${getNumberColor(leaderAllTimeProfit(list))}`}>
                                {renderPercent(leaderAllTimeProfit(list))}
                            </Text>
                            <Text className={`text-body3 ${getNumberColor(leaderMonthlyProfit(list))}`}>
                                30d {renderPercent(leaderMonthlyProfit(list))}
                            </Text>
                        </div>
                        <div className={'md:hidden sm:text-center'}>
                            <Text className={'hidden sm:block text-ti3 text-font03'}>MDD</Text>
                            <Text className={'text-ti2'}>{renderPercent(list?.mdd ?? 0)}</Text>
                        </div>
                        <div className={'sm:text-center'}>
                            <Text className={'hidden sm:block text-ti3 text-font03'}>Copiers</Text>
                            <Span>{list?.copier}</Span> / <Span>{list?.max_copier}</Span>
                        </div>
                    </TableItem>
                ))}
                {!data?.length && (
                    <TableItem className={'text-center'}>
                        <div>
                            <Text>No Items</Text>
                        </div>
                    </TableItem>
                )}
            </TableLayout>
        </div>
    )
}

export default LeaderListTable
